import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "expertise-section__predictor-title" }
const _hoisted_2 = { class: "expertise-section__predictor-subtitle" }
const _hoisted_3 = {
  key: 0,
  class: "custom-font-text"
}
const _hoisted_4 = ["selected"]
const _hoisted_5 = ["value", "selected"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "expertise-section__predictor-manual-category-title" }
const _hoisted_8 = { class: "expertise-section__predictor-manual-category-select" }
const _hoisted_9 = ["checked", "name", "value"]
const _hoisted_10 = {
  slot: "checkbox-content",
  class: "checkbox__category-content"
}
const _hoisted_11 = { class: "checkbox__category-label" }
const _hoisted_12 = {
  key: 2,
  class: "other-category-input"
}

import {ProfileFamily} from '@/profile-creation-wizard/common/categories/FamiliesCategories';
    import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import {computed, onMounted, onBeforeMount, ref, reactive} from 'vue';
    import {useTranslation} from '@malt/vue3-use';

    export interface Props {
        families: ProfileFamily[];
        preferredFamily?: string;
        categories: string[];
        hadPredictions: boolean;
        closestParentSelector?: string;
        suggestedCategory?: string;
        bottomSheetSelector?: string;
    }
    
export default /*@__PURE__*/_defineComponent({
  __name: 'CategorizationManualSelection',
  props: {
    families: {},
    preferredFamily: {},
    categories: {},
    hadPredictions: { type: Boolean },
    closestParentSelector: { default: '' },
    suggestedCategory: {},
    bottomSheetSelector: {}
  },
  emits: ["manual-selection", "unselectCategories", "goBack", "inputFamily", "inputCategory", "otherCategoryChange"],
  setup(__props: any, { emit: __emit }) {

    const emit = __emit;

    const {msg} = useTranslation();

    const props = __props;

    const customSuggestedCategory = ref(props.suggestedCategory);

    const state = reactive<{
        selectedFamilyId: string | null;
        selectedCategories: string[];
    }>({
        selectedFamilyId: props.preferredFamily,
        selectedCategories: props.categories,
    });

    let bottomSheetDisplayer: BottomSheetDisplayer;
    const rootElement = ref<HTMLElement | null>(null);
    const hasFamilySelected = computed(() => findSelectedFamily.value.length > 0);
    const hasChoseOtherFamily = computed(() => findSelectedFamily.value.map((family) => family.familyId).includes('other'));
    const linkedCategories = computed(() => findSelectedFamily.value.flatMap((family) => family.categories));
    const findSelectedFamily = computed(() => props.families.filter((family) => family.familyId === state.selectedFamilyId));

    onMounted(() => {
        bottomSheetDisplayer = new BottomSheetDisplayer(props.bottomSheetSelector, rootElement.value, props.closestParentSelector);
    });

    onBeforeMount(() => {
        if (state.selectedCategories.length === 0) {
            emit('manual-selection');
        }
    });

    function openBottomSheet() {
        bottomSheetDisplayer.openBottomSheet();
    }

    function manualFamilySelected(value: typeof state.selectedFamilyId) {
        state.selectedCategories = [];
        emit('inputFamily', value);
    }

    function toggleCategory(event: Event) {
        const toggledCategory = (event.target as HTMLInputElement).value;

        if (state.selectedCategories.includes(toggledCategory)) {
            state.selectedCategories = state.selectedCategories.filter((categ) => categ !== toggledCategory);
        } else {
            state.selectedCategories.push(toggledCategory);
        }

        emit('inputCategory', state.selectedCategories);
    }

    function isToggled(category: string): boolean {
        return props.categories.includes(category);
    }

    function isExpertise(category: string): boolean {
        return props.categories[0] === category;
    }

    function isFamilySelected(family: ProfileFamily): boolean {
        return findSelectedFamily.value.includes(family);
    }

    function otherCategoryChange(eventDetail: string): void {
        emit('otherCategoryChange', eventDetail);
    }

    function unselectCategories(): void {
        emit('unselectCategories');
    }

    function goBack(): void {
        unselectCategories();
        emit('goBack');
    }

return (_ctx: any,_cache: any) => {
  const _component_VJoySelect = _resolveComponent("VJoySelect")!
  const _component_VJoyTag = _resolveComponent("VJoyTag")!
  const _component_VJoyInput = _resolveComponent("VJoyInput")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "rootElement",
    ref: rootElement
  }, [
    _createElementVNode("div", {
      class: _normalizeClass({
                'expertise-section__predictor': true,
                'had-predictions': _ctx.hadPredictions,
            })
    }, [
      _withDirectives(_createElementVNode("div", {
        class: "expertise-section__predictor-goback",
        onClick: goBack
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("joy-icon", { name: "arrow-left" }, null, -1)
      ]), 512), [
        [_vShow, _ctx.hadPredictions]
      ]),
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(msg)('profile.creation.predictor.wizard.details.manual.expertise.title')), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(msg)('profile.creation.predictor.wizard.details.manual.expertise.subtitle')), 1),
      (_ctx.bottomSheetSelector)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
            _createElementVNode("a", {
              class: "open-bottom-sheet",
              onClick: openBottomSheet
            }, _toDisplayString(_unref(msg)('profile.creation.predictor.wizard.details.expertise.help')), 1)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_VJoySelect, {
        modelValue: state.selectedFamilyId,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((state.selectedFamilyId) = $event)),
          manualFamilySelected
        ],
        class: "expertise-section__predictor-manual-family-select joy-mb-6"
      }, {
        default: _withCtx(() => [
          _createElementVNode("option", {
            disabled: "",
            selected: !hasFamilySelected.value,
            value: ""
          }, _toDisplayString(_unref(msg)('profile.creation.predictor.wizard.details.manual.expertise.family.selection')), 9, _hoisted_4),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.families, (family) => {
            return (_openBlock(), _createElementBlock("option", {
              key: family.familyId,
              value: family.familyId,
              selected: isFamilySelected(family)
            }, _toDisplayString(family.label), 9, _hoisted_5))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (hasFamilySelected.value && !hasChoseOtherFamily.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(msg)('profile.creation.predictor.wizard.details.manual.expertise.family.subtitle')), 1),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(linkedCategories.value, (category) => {
                return (_openBlock(), _createElementBlock("label", {
                  key: category.categoryId,
                  class: "m-checkbox select-category"
                }, [
                  _createElementVNode("joy-checkbox", {
                    class: _normalizeClass(["checkbox__category sc-joy-checkbox-h sc-joy-checkbox-s", {
                                'is-selected': isToggled(category.categoryId),
                                'is-expertise': isExpertise(`${category}`),
                            }]),
                    checked: isToggled(category.categoryId),
                    name: category.categoryId,
                    value: category.categoryId,
                    onChange: toggleCategory
                  }, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(category.label), 1),
                      (isExpertise(category.categoryId))
                        ? (_openBlock(), _createBlock(_component_VJoyTag, {
                            key: 0,
                            label: _unref(msg)('profile.creation.predictor.wizard.v2.details.expertise.main'),
                            variant: "secondary",
                            size: "small",
                            class: "checkbox__category-expertise responsive-content"
                          }, null, 8, ["label"]))
                        : _createCommentVNode("", true)
                    ])
                  ], 42, _hoisted_9)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (hasChoseOtherFamily.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_VJoyInput, {
              modelValue: customSuggestedCategory.value,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((customSuggestedCategory).value = $event)),
                otherCategoryChange
              ],
              placeholder: _unref(msg)('profile.creation.predictor.wizard.details.manual.expertise.category.placeholder'),
              autocomplete: "off",
              name: "other-category"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.predictor.wizard.details.manual.expertise.category.select')), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 512))
}
}

})